module.exports = __webpack_public_path__ + "fonts/MessinaSansWeb-Book.064fc463.woff";